import React from "react";
import {
  colorWhite,
  primaryColor,
} from "../../../utility/constants/colorManager";

function Avatar({ size = 30, color, name }) {
  return (
    <div
      style={{
        height: size,
        width: size,
        backgroundColor: color ? color : primaryColor,
        borderRadius: size / 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textTransform: "capitalize",
      }}
    >
      <p
        style={{
          color: colorWhite,
          fontSize: 14,
        }}
      >
        {name.slice(0, 1)}
      </p>
    </div>
  );
}

export default Avatar;
